import React, { useState } from 'react';
import { TOffer, TPartner } from 'types/offers-temporary';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faTrash, faPencil, faImage } from '@fortawesome/free-solid-svg-icons';
import { getOfferImageUrl, hasOfferImage } from 'utils/offer-image';

interface OffersListItemProps {
  offer: TOffer;
  partner: TPartner;
  index: number;
  onRemove: (offerId: number) => void;
  onToggleHidden: (offerId: number, hidden: boolean) => void;
  onEdit?: (offer: TOffer) => void;
  isHidden?: boolean;
}

const OffersListItem: React.FC<OffersListItemProps> = ({ 
  offer, 
  partner, 
  index,
  onRemove,
  onToggleHidden,
  onEdit,
  isHidden = false
}) => {
  const [isRemoving, setIsRemoving] = useState(false);

  const handleTrashClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    const confirmed = window.confirm(`Видалити офер "${offer.caption || offer.name}" зі списку?`);
    if (confirmed) {
      setIsRemoving(true);
      setTimeout(() => {
        onRemove(offer.id);
      }, 300); // Wait for fade animation
    }
  };

  return (
    <div
      className={`offers-list-item ${isRemoving ? 'removing' : ''}`}
      data-draggable="true"
    >
      <div className="offers-list-item__logo">
        {hasOfferImage(offer) ? (
          <img
            src={getOfferImageUrl(offer, 'bg')}
            alt={offer.name}
            className="offers-list-item__thumbnail offers-list-item__thumbnail--bg"
          />
        ) : (
          <div className="offers-list-item__placeholder">
            <FontAwesomeIcon icon={faImage} />
          </div>
        )}
      </div>
      <div className="offers-list-item__details">
        <div className="offers-list-item__name">{offer.caption}</div>
        <div className="offers-list-item__partner">{partner?.name}</div>
      </div>
      <div className="offers-list-item__actions">
        <div 
          className={`offers-list-item__icon offers-list-item__icon--eye ${isHidden ? 'hidden' : ''}`}
          onClick={(e) => {
            e.stopPropagation();
            onToggleHidden(offer.id, !isHidden);
          }}
        >
          <FontAwesomeIcon icon={faEye} />
          <div className="eye-slash">
            <FontAwesomeIcon icon={faEyeSlash} />
          </div>
        </div>
        {onEdit && (
          <div 
            className="offers-list-item__icon offers-list-item__icon--edit"
            onClick={(e) => {
              e.stopPropagation();
              onEdit(offer);
            }}
            title="Редагувати"
          >
            <FontAwesomeIcon icon={faPencil} />
          </div>
        )}
        <div 
          className="offers-list-item__icon offers-list-item__icon--trash"
          onClick={handleTrashClick}
          title="Видалити зі списку"
        >
          <FontAwesomeIcon 
            icon={faTrash} 
            className="trash-icon"
          />
        </div>
      </div>
    </div>
  );
};

export default OffersListItem;
